export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4624.cd477c21.jpg";